export default "__VITE_ASSET__BlaS6TTW__"